<ngx-loading [show]="loading"></ngx-loading>

<!-- START Top Navbar-->
<div class="topnavbar-container" [ngClass]="{'custom-branding': menu.hasBrandingPermission && styleService.brandingStyle}" [ngStyle]="menu.hasBrandingPermission && styleService.brandingStyle ? {'background': styleService.brandingStyle?.backgroundColor, 'color': styleService.brandingStyle?.textColor} : {'color': '#ffffff'}">
    <nav class="navbar topnavbar" role="navigation">
        <!-- START navbar header-->
        <div class="navbar-header">
            <!-- Products -->
            <app-products [tenantId]="defaultTenantId" [iconColor]="styleService?.brandingStyle?.textColor"></app-products>
            <app-support-chat></app-support-chat>

            <a class="navbar-brand" href="#">
                <ng-container *ngIf="menu.hasBrandingPermission && styleService.brandingStyle; then brandLogo; else defaultlogo"></ng-container>
            </a>
        </div>
        <!-- END navbar header-->
        <!-- START Left navbar-->
        <ul class="navbar-nav mr-auto flex-row">
            <li class="nav-item">
                <!-- Button to show/hide the sidebar on mobile. Visible on mobile only.-->
                <a class="nav-link sidebar-toggle d-lg-none d-xl-none"
                    (click)="settings.layout.asideToggled =! settings.layout.asideToggled; $event.stopPropagation()">
                    <em class="fa fa-navicon"></em>
                </a>
            </li>
        </ul>
        <!-- END Left navbar-->

        <!-- START Right Navbar-->
        <ul class="navbar-nav flex-row align-items-center justify-content-center">
            <!-- Notifications -->
            <li class="nav-item">
                <a class="nav-link" (click)="openNotifications(notificationsUser)" href="#">
                    <em class="fa fa-bell"></em>
                </a>
            </li>

            <!-- Tasks -->
            <li class="nav-item">
                <a class="nav-link" (click)="openTasks(notesAttendees)" href="#">
                    <em class="fa fa-check-square-o"></em>
                </a>
            </li>

            <!-- Support -->
            <ng-container *ngIf="isSupport; else dashboardUserNav">
                <li class="nav-item" *ngIf="isSupport">
                    <a class="nav-link" title="{{ 'LAYOUT.HEADER.SUPPORTEDTENANT' | translate }}" href="#">
                        <em class="icon-support mr-1" style="text-align: center;"></em> {{ supportingTenant?.text}}
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" title="{{ 'LAYOUT.HEADER.ENDSUPPORTSESSION' | translate }}" (click)="logout()" href="#">
                        <em class="fa fa-sign-out mr-1"></em> {{ 'LAYOUT.HEADER.ENDSUPPORTSESSION' | translate }}
                    </a>
                </li>
            </ng-container>

            <ng-template #dashboardUserNav>
                <!-- Tenant selection -->
                <li class="nav-item user-block-tenant dropdown-tenant" *ngIf="!isSupport && tenants?.length > 1">
                    <ngx-select
                            [allowClear]="false"
                            [noAutoComplete]="true"
                            [items]="tenants"
                            [defaultValue]="defaultTenantId"
                            appendTo="body"
                            (select)="changeTenant($event)">    
                    </ngx-select>
                </li>
                <!-- Logout -->
                <li class="nav-item nav-item-user" #navDropdown closeOnOutsideClick [items]="dropdownItems" (outsideClick)="showUserAccount = false">
                    <em (click)="showUserAccount = !showUserAccount" class="nav-link fa fa-user-circle-o"></em>
                    <div [ngClass]="{'opening': showUserAccount}" class="nav-dropdown">
                        <a class="nav-link sign-in-user" title="{{ 'LAYOUT.HEADER.USER' | translate }}" href="#">
                            {{ 'LAYOUT.HEADER.USER' | translate }}<br/><strong>{{ userName }}</strong>
                        </a>
                        <hr class="mt-0 mb-0" />
                        <a class="nav-link" title="{{ 'LAYOUT.HEADER.SIGNOUT' | translate }}" (click)="logout()" href="#">
                            <em class="fa fa-sign-out"></em> {{ 'LAYOUT.HEADER.SIGNOUT' | translate }}
                        </a>
                    </div>
                </li>
            </ng-template>
        </ul>
        <!-- END Right Navbar-->

        <app-navsearch [visible]="getNavSearchVisible()" (onclose)="setNavSearchVisible(false)"></app-navsearch>

    </nav>
</div>
<!-- END Top Navbar-->

<!-- START Horizontal Navbar-->
<app-horizontal class="horizontal-nav"></app-horizontal>
<!-- END Horizontal Navbar-->

<ng-template #notificationsUser>
    <app-components-modal-form-host [modal]="modal" [title]="'LAYOUT.HEADER.NOTIFICATIONS' | translate" [icon]="'fa fa-bell'" [status]="status" [error]="error" [buttons]="buttonSets.Close">
        <app-notifications [notifications]="notifications"></app-notifications>
    </app-components-modal-form-host>
</ng-template>

<ng-template #notesAttendees>
    <app-components-modal-form-host [modal]="modal" [title]="'LAYOUT.HEADER.TASKS' | translate"
        [icon]="'fa fa-check-square-o'" [status]="status" [error]="error" [buttons]="buttonSets.SaveCancel"
        [formId]="'attendeesNotes'">
        <app-tasks [attendeesNotes]="attendeesNotes" (formSubmitted)="submitNotesAttendees($event)"></app-tasks>
    </app-components-modal-form-host>
</ng-template>

<ng-template #defaultlogo>
    <div class="brand-logo">
        <img class="img-fluid header-logo" src="assets/img/invitedesk-logo-white.svg" alt="App Logo" [routerLink]="'/events'" />
    </div>
</ng-template>

<ng-template #brandLogo>
    <div class="brand-logo">
        <img class="img-fluid header-logo" *ngIf="styleService.brandingStyle?.imageUrl" [src]="styleService.brandingStyle?.imageUrl" alt="App Logo" [routerLink]="'/events'" />
    </div>
</ng-template>
